<footer>
  <div class="container">
    <div class="row g-4">
      <!-- Logo and Description -->
      <div class="col-sm-3">
        <!-- <img src="assets/images/Shiv-logo.png" class="img-fluid mb-4"> -->
        <img src="assets/images/shiv-white-logo.svg" class="img-fluid mb-4" />
        <p>{{ "footer.description" | translate }}</p>
      </div>

      <!-- More Links -->
      <div class="col-sm-6">
        <h5 class="fw-bold mb-3">{{ "footer.more_links" | translate }}</h5>
        <ul class="footerlinks">
          <li>
            <a routerLink="/home">{{ "web_header.home" | translate }}</a>
          </li>
          <li>
            <a routerLink="/about">{{ "web_header.about_us" | translate }}</a>
          </li>
          <li>
            <a routerLink="/leadership">{{
              "web_header.leadership" | translate
            }}</a>
          </li>
          <li>
            <a>{{ "web_header.social_work" | translate }}</a>
          </li>
          <li>
            <a routerLink="/media-gallery">{{
              "web_header.media_gallery" | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/news-and-event">{{
              "web_header.news_and_events" | translate
            }}</a>
          </li>
          <li>
            <a routerLink="/suggetions">{{
              "web_header.suggestions" | translate
            }}</a>
          </li>
          <li>
            <a>{{ "web_header.current_affairs" | translate }}</a>
          </li>
          <li>
            <a routerLink="/contact-us">{{
              "web_header.contact" | translate
            }}</a>
          </li>
          <li>
            <a
              href="https://join.shivsankalp.org/join-us"
              target="_blank"
              rel="noopener noreferrer"
              >{{ "footer.join_us" | translate }}</a
            >
          </li>
        </ul>
      </div>

      <!-- Contact Details -->
      <div class="col-sm-3">
        <h5 class="fw-bold mb-3">{{ "footer.contact_us" | translate }}</h5>

        <div class="d-flex mb-3">
          <div class="flex-shrink-0">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            {{ "footer.address" | translate }}
          </div>
        </div>

        <div class="d-flex mb-3">
          <div class="flex-shrink-0">
            <i class="fas fa-phone-alt"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            {{ "footer.phone" | translate }}
          </div>
        </div>

        <div class="d-flex mb-3">
          <div class="flex-shrink-0">
            <i class="far fa-envelope"></i>
          </div>
          <div class="flex-grow-1 ms-3">
            <a href="mailto:{{ 'footer.email' | translate }}">{{
              "footer.email" | translate
            }}</a>
          </div>
        </div>

        <!-- Social Icons -->
        <div class="social-icons">
          <a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="#" target="_blank"><i class="fab fa-twitter"></i></a>
          <a href="#" target="_blank"><i class="fab fa-instagram"></i></a>
          <a href="#" target="_blank"><i class="fab fa-youtube"></i></a>
        </div>
      </div>
    </div>
  </div>
</footer>

<button
  class="go-top-btn"
  title="Go to top"
  *ngIf="showGoTop"
  (click)="scrollToTop()"
>
  <i class="fas fa-arrow-up"></i>
</button>
